import React from "react";

const FullPageLoader = ({ text = "" }) => {
  return (
    <div className="loader-container">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="text-dark mt-1">{text}</p>
    </div>
  );
};

export default FullPageLoader;
